/** Nome legível para itens de foto em pedidos (SKU FOTO-XXXXXXXX). */
export function formatFotoItemPedidoNome(item: {
  sku?: string | null;
  produtoNome?: string | null;
}): string | null {
  const sku = item.sku?.toUpperCase();
  if (!sku?.startsWith("FOTO-")) return null;

  const shortId = sku.slice(5);
  const resMatch = item.produtoNome?.match(
    /(?:·|\()\s*(Alta|Média|Baixa|Media|MEDIA|ALTA|BAIXA)\s*\)?/i,
  );
  if (resMatch?.[1]) {
    const raw = resMatch[1].toLowerCase();
    const res =
      raw === "media" || raw === "média"
        ? "Média"
        : raw === "alta"
          ? "Alta"
          : raw === "baixa"
            ? "Baixa"
            : resMatch[1];
    return `Foto #${shortId} · ${res}`;
  }

  return `Foto #${shortId}`;
}

export function labelProdutoPedidoItem(item: {
  sku?: string | null;
  produtoNome?: string | null;
}): string {
  const foto = formatFotoItemPedidoNome(item);
  if (foto) return foto;
  const nome = String(item.produtoNome ?? "").trim();
  return nome || "—";
}
